/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getConsumerKycConfigFromProps } from '../helpers';
import type { MoonPayConsumerKycProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

/**
 * @deprecated
 */
export function MoonPayConsumerKycWidget(props: MoonPayConsumerKycProps) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getConsumerKycConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
